import {useSelector} from 'react-redux';
import {RootState} from '../../shared/state/root-reducer';
import {useEffect} from 'react';
import {patientService} from '../../patient/services/patient-service';

export const useIsDisabledAfterConvert = () => {

  const selectedEncounter = useSelector((state: RootState) => state.patientContext.selectedEncounter);
  const estimate = useSelector(
      (state: RootState) => {
        return state?.admissionsAdvisorContext.estimatorContext.estimate
      }
  );
  const vobPatientState = useSelector(
      (state: RootState) => state.admissionsAdvisorContext.vobPatientContext
  )

  let instanceOfCare = selectedEncounter

  useEffect(() => {

    const getEstimateIOC = async () => {

      //estimate.patientEncounterId is the IOC the estimate is tied to.
      if(estimate?.patientEncounterId! && estimate?.patientEncounterId! !== selectedEncounter.patientEncounterId ) {

        //Don't override Redux state since that might cause issues where this hook is being used
        const response = await patientService.getPatientInstanceOfCare({patientId: vobPatientState.patient.fpPatientId!, encounterId: estimate?.patientEncounterId!});

        instanceOfCare = response?.entity

      }

    };

    getEstimateIOC()

  }, [estimate, selectedEncounter]);

  const isIOCConverted = selectedEncounter?.workflow?.workflowId === 3;
  
  let isOriginalEstimateToIOC = false;

  if(instanceOfCare) {
    isOriginalEstimateToIOC = estimate?.estimateId === instanceOfCare.pfrEstimateId
  } 

  return isIOCConverted && isOriginalEstimateToIOC;


}